import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import Login from "pages/login";
import Dashboard from "pages/dashboard";
import InventoryControl from "pages/inventory-control";
import ProductCatalogManagement from "pages/product-catalog-management";
import QuotationManagement from "pages/quotation-management";
import InvoiceManagement from "pages/invoice-management";
import DeliveryNotesManagement from "pages/delivery-notes-management";
import OrderFulfillmentTracking from "pages/order-fulfillment-tracking";
import ProductManagement from "pages/product-management";
import CustomerDatabase from "pages/customer-database";
import ReportsAndAnalytics from "pages/reports-and-analytics";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inventory-control" element={<InventoryControl />} />
        <Route path="/product-catalog-management" element={<ProductCatalogManagement />} />
        <Route path="/product-management" element={<ProductManagement />} />
        <Route path="/quotation-management" element={<QuotationManagement />} />
        <Route path="/invoice-management" element={<InvoiceManagement />} />
        <Route path="/delivery-notes-management" element={<DeliveryNotesManagement />} />
        <Route path="/order-fulfillment-tracking" element={<OrderFulfillmentTracking />} />
        <Route path="/customer-database" element={<CustomerDatabase />} />
        <Route path="/reports-analytics" element={<ReportsAndAnalytics />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;